/* import __COLOCATED_TEMPLATE__ from './missing-predicate.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();